import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { AdvisorState } from "./advisorInterfaces";

const initialState: AdvisorState = {
  isAdvisor: false,
};

const advisorSlice = createSlice({
  name: "advisor",
  initialState,
  reducers: {
    setAdvisor: (
      state,
      action: PayloadAction<{
        cartId: string;
      }>,
    ) => {
      state.isAdvisor = true;
      state.cartId = action.payload.cartId;
    },
  },
});

export const { setAdvisor } = advisorSlice.actions;
export const advisor = advisorSlice.reducer;
